<div class="col-xs-12 col-sm-6 col-md-3 u-mb-mobile" id="{{model.id}}">
    <div class="ib-radio-board ib-radio-board--type-{{model.backGroundType}}" data-equal="card-box">
        <input *ngIf="model.checked" class="ib-radio-board__input"
                type="radio"
                name="card"
                checked
                id="{{model.inputId}}"
                value="{{model.value}}"
                (click)="updateQuadrigam()"
        />
        <input *ngIf="!model.checked" class="ib-radio-board__input"
                type="radio"
                name="card"
                id="{{model.inputId}}"
                value="{{model.value}}"
                (click)="updateQuadrigam()"
        />
        <figure class="ib-radio-board__figure ib-radio-board__figure--{{model.figureClassType}}">
            <img src="../iberia-web-content/imagenes/gift-cards/{{model.imgIcon}}.png"
                alt="{{'{{model.text}}'|translate}}" />
        </figure>
        <label class="ib-radio-board__label" for="{{model.inputId}}">
            <span class="ib-radio-board__text">{{cardText}}</span>
        </label>
    </div>
</div>